// offset doit être la valeur du header fixe s'il y en a un, sinon l'header
// va se retrouver par-dessus le début de la section
export default function scrollToNode({
  node,
  offset,
  force = false
}) {
  if (!node || typeof node.getBoundingClientRect !== 'function') return;
  const position = node.getBoundingClientRect();
  if (!force && position.top < 0 && position.bottom > window.innerHeight) {
    return; // l'élément est visible et prend plus que la hauteur de la page
  }

  const scrolled = document.scrollingElement.scrollTop;
  const added_offset = parseInt(offset) > 0 ? parseInt(offset) : 0;
  document.scrollingElement.scrollTo({
    top: position.top + scrolled - added_offset,
    behavior: 'smooth'
  });
}
